const PROFILEVIEW = {
  cropImage: "Recortar Imagen",
  changePassword: "Cambiar contraseña",
  address: "Dirección",
  textValidationAddress: "Verifique que la estructura de la dirección sea ejemplo: Calle 84 24 - 78, Bogotá",
  profileUser: "Perfíl de usuario",
  name: "Nombre",
  enterName: "Ingrese el nombre",
  lastname: "Apellido",
  enterLastname: "Ingrese el apellido",
  company: "Compañía",
  enterCompany: "Ingrese el nombre de la compañía",
  department: "Departamento",
  city: "Ciudad",
  rol: "Rol",
  enterRol: "Ingrese nombre del rol",
  local: "Local",
  update: "Actualizar",
  matchPassword: "Los passwords no coinciden.",
  user: "Usuario",
  EmptyFields: "Faltan campos por completar",
  updateUser: "Usuario actualizado correctamente."
};

export default { PROFILEVIEW };
